import {
    APPLY_DISCOUNT,
} from "./types";

import CouponService from "../services/CouponService";

export const validateCoupon = (data) => async (dispatch) => {
    try {
        const res = await CouponService.verifyCoupon(data);
        if(res.error) {
            return {error: res.error};
        } 
        const { coupon: { code, description, discount_amount: amount, is_fixed: isFixed }, error } = res;
        const payload = { code, description, amount, isFixed, error };
        dispatch({
            type: APPLY_DISCOUNT,
            payload,
        });
        // Let the caller act on the result once (e.g. adjust the total price)
        // without re-deriving it from store changes.
        return { coupon: payload };
    } catch (err) {
        console.log(err);
    }
};
